export const CONVERSATION_LIST_PAGE_SIZE = 25;

export const CONVERSATION_LIST_LOAD_MORE_PAGE_SIZE = 75;

export const CONVERSATION_LIST_PAGINATION_EXPERIMENT = 'rovo_chat_conversation_list_pagination';
